import type { UseQueryReturnType } from '@tanstack/vue-query';

import type { WaitQueryFetchedOptions } from '../types';
import waitQueryPromiseHelper from './waitQueryPromiseHelper';

/**
 * Wait query isFetched flag
 */
export default async function waitQueryFetched<T, TError>(
  query: UseQueryReturnType<T, TError>,
  { stopRefetch }: WaitQueryFetchedOptions = {},
): Promise<T> {
  const {
    isStale,
    data,
    isFetched,
    error,
  } = query;
  if (!stopRefetch && isStale.value) {
    await query.refetch();
  }

  return new Promise<T>((resolve, reject) => {
    waitQueryPromiseHelper(isFetched, data, error, resolve, reject);
  });
}
